import asyncActionTypes from '../../actions/types';

const initialState = {
  billingMail: '',
  billingPostalCode: '',
  cfdiUse: '',
  error: '',
  rfc: '',
  socialReason: '',
  taxRegime: '',
  typeOfRfc: '',
};

const billingData = ( state = initialState, action ) => {
  switch (action.type) {
    case asyncActionTypes.SET_BILLING_DATA.START:
      return {
        ...initialState,
      };
    case asyncActionTypes.SET_BILLING_DATA.SUCCESS:
      return {
        ...state,
        billingMail: action?.payload?.billingMail,
        billingPostalCode: action?.payload?.billingPostalCode,
        cfdiUse: action?.payload?.cfdiUse,
        rfc: action?.payload?.rfc,
        socialReason: action?.payload?.socialReason,
        taxRegime: action?.payload?.taxRegime,
        typeOfRfc: action?.payload?.typeOfRfc,
      };
    case asyncActionTypes.SET_BILLING_DATA.FAIL:
      return {
        ...initialState,
        error: action?.error,
      };
    default:
      return state;
  }
};

export default billingData;